import { render, staticRenderFns } from "./D3PercentageDonutChart.vue?vue&type=template&id=283e62ec&scoped=true"
import script from "./D3PercentageDonutChart.vue?vue&type=script&lang=js"
export * from "./D3PercentageDonutChart.vue?vue&type=script&lang=js"
import style0 from "./D3PercentageDonutChart.vue?vue&type=style&index=0&id=283e62ec&prod&lang=scss&scoped=true"
import style1 from "./D3PercentageDonutChart.vue?vue&type=style&index=1&id=283e62ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e62ec",
  null
  
)

export default component.exports